import React, { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export default function ResetPasswordPage() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm]   = useState("");
  const [done, setDone]         = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");

  const token = new URLSearchParams(window.location.search).get("token") || "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setError(""); setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Reset failed. Try requesting a new link.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex flex-col items-center justify-center px-4"
      style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
      <h1 className="text-5xl tracking-[0.25em] uppercase font-light text-[#1A1A1A] mb-8">Arvay</h1>
      <div className="w-full max-w-sm bg-white border border-[#E8E8E4] shadow-sm p-8">
        {done ? (
          <div className="text-center">
            <h2 className="text-xl font-light tracking-wider mb-4">Password Updated</h2>
            <p className="font-sans text-xs text-neutral-500 mb-6">You can now sign in with your new password.</p>
            <a href="/" className="font-sans text-[10px] uppercase tracking-[0.18em] font-semibold underline">Sign In</a>
          </div>
        ) : (
          <>
            <h2 className="text-xl font-light tracking-wider mb-6">New Password</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="font-sans text-[10px] uppercase tracking-[0.18em] text-neutral-500 font-semibold block mb-1.5">New Password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
                  placeholder="Min. 6 characters" data-testid="reset-password-input"
                  className="w-full border border-[#E0E0E0] bg-[#FAFAF8] px-3 py-2.5 font-sans text-sm focus:outline-none focus:border-black transition-colors placeholder:text-neutral-300"/>
              </div>
              <div>
                <label className="font-sans text-[10px] uppercase tracking-[0.18em] text-neutral-500 font-semibold block mb-1.5">Confirm Password</label>
                <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required
                  placeholder="Repeat password" data-testid="reset-confirm-input"
                  className="w-full border border-[#E0E0E0] bg-[#FAFAF8] px-3 py-2.5 font-sans text-sm focus:outline-none focus:border-black transition-colors placeholder:text-neutral-300"/>
              </div>
              {error && <p className="font-sans text-xs text-red-600">{error}</p>}
              <button type="submit" disabled={loading} data-testid="reset-submit-btn"
                className="w-full bg-black text-white font-sans text-[10px] uppercase tracking-[0.2em] font-semibold py-3.5 hover:bg-neutral-800 disabled:opacity-50">
                {loading ? "Updating…" : "Update Password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
